<template>
    <button
        :aria-label="label"
        class="inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-gray-800 text-white disabled:cursor-not-allowed disabled:opacity-50"
        :data-testid="`${testidPrefix}-update-button`"
        type="button"
        :disabled="disabled"
        @click="emit('click')"
    >
        <icon
            aria-hidden="true"
            class="h-3 w-3"
            :data-testid="`${testidPrefix}-update-submit-icon`"
            name="regular/arrow-up"
        />
    </button>
</template>

<script setup lang="ts">
    defineProps<{
        disabled: boolean;
        label: string;
        testidPrefix: string;
    }>();

    const emit = defineEmits<{
        click: [];
    }>();
</script>
